<div class="w-100">
    <div class="page-info"><h3 style="margin: 25px; font-weight: 500; font-size:25px; color: #2a457a;">Ledger Head</h3></div>
</div>
<div class="table-container" style="margin-left: 20px; margin-right: 20px;">
    <div class="w-100 border-p">
        <div class="mt-10 w-100 ">
            <!-- Ledger Name -->
            <mat-form-field class="w-30 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Ledger Name</mat-label>
                <input matInput placeholder="Enter Ledger Name" [(ngModel)]="l_formData.name">
            </mat-form-field>
            <!-- Entry Type -->
            <mat-form-field class="w-20 pl-20 " appearance="outline">
                <mat-label class="custom-mat-label">Entry Type</mat-label>
                <mat-select matNativeControl required [(ngModel)]="l_formData.entryType">
                    <mat-option *ngFor="let l_entityType of entityTypeEnum" [value]="l_entityType.entryType">
                        {{ l_entityType.viewValue }}</mat-option>
                </mat-select>
            </mat-form-field>
            <!-- Is Deemed Positive? -->
            <mat-slide-toggle class="w-20 pl-20" [checked]="l_isdeemed" (change)="lFN_OnToggleChange($event)">
                <mat-label class="custom-mat-label">{{ l_isdeemedLabel }}</mat-label>
            </mat-slide-toggle>
            <!-- Status -->
            <mat-form-field class="w-30 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Status</mat-label>
                <input matInput placeholder="Enter Status" [(ngModel)]="l_formData.status">
            </mat-form-field>
            <!-- Save -->
            <button mat-raised-button color="primary" class="custom-button-blue pl-20"
            style="margin-top: 4px; margin-left: 10px;" (click)="''">Submit
        </button>
        </div>
    </div>
</div>
<div class="mat-elevation-z8 table-container" style="margin-left: 20px; margin-right: 20px; margin-top: 30px;">
    <table mat-table [dataSource]="dataSource" class="mat-table">
         <!-- Ledger Name -->
         <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Ledger Name</th>
            <td mat-cell *matCellDef="let element">{{element.name}}</td>
        </ng-container>
        <!-- Entry Type -->
        <ng-container matColumnDef="entryType">
            <th mat-header-cell *matHeaderCellDef>Entry Type</th>
            <td mat-cell *matCellDef="let element">{{element.entryType}}</td>
        </ng-container>
        <!-- Is Deemed Positive? -->
        <ng-container matColumnDef="isDeemedPositive">
            <th mat-header-cell *matHeaderCellDef>Is Deemed Positive?</th>
            <td mat-cell *matCellDef="let element">{{element.isDeemedPositive}}</td>
        </ng-container>
        <!-- Approval Status Column -->
        <ng-container matColumnDef="approvalStatus">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element" class="actions-cell">
                <button mat-icon-button *ngIf="element.approvalStatus === false" (click)="lFN_ApproveMapping(element);">
                    <mat-chip class="status-chip active-status">
                        <mat-label>Approve</mat-label>
                    </mat-chip>
                </button>
                <button mat-icon-button *ngIf="element.approvalStatus === true">
                    <mat-chip class="status-chip final-status">
                        <mat-label>Mapped</mat-label>
                    </mat-chip>
                </button>
            </td>
        </ng-container>
        <!-- Actions -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>&nbsp;&nbsp;&nbsp;Actions</th>
            <td mat-cell *matCellDef="let element" class="actions-cell">
                <button mat-icon-button (click)="(element);">
                    <mat-icon title="Edit Receipt" style="-webkit-text-fill-color: #2a457a">edit</mat-icon>
                </button>
                <button mat-icon-button (click)="lFN_viewLedgerHead(element);">
                    <mat-icon title="View Details" style="-webkit-text-fill-color: #2a457a">visibility</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>